/* The gallery Swiper is created by rc-carousel.js; look it up off the
   element rather than holding a local reference. */
function rcGallerySwiper() {
  var el = document.querySelector(".tf-product-media-main");
  return el && el.swiper ? el.swiper : null;
}

/* Gallery Swiper init removed - rc-carousel.js owns carousels and
   rc-product.js owns colour-to-gallery syncing. */

/* Gallery Swiper init removed - rc-carousel.js owns carousels and
   rc-product.js owns colour-to-gallery syncing. */

/* Gallery Swiper init removed - rc-carousel.js owns carousels and
   rc-product.js owns colour-to-gallery syncing. */

/* Gallery Swiper init removed - rc-carousel.js owns carousels and
   rc-product.js owns colour-to-gallery syncing. */

/* Gallery Swiper init removed - rc-carousel.js owns carousels and
   rc-product.js owns colour-to-gallery syncing. */


(function ($) {
    "use strict";

    var section_zoom = function () {
        $(".tf-image-zoom").on("mouseover", function () {
            $(this).closest(".section-image-zoom").addClass("zoom-active");
        });
        $(".tf-image-zoom").on("mouseleave", function () {
            $(this).closest(".section-image-zoom").removeClass("zoom-active");
        });
    }

    var image_zoom = function () {
      if (matchMedia("only screen and (min-width: 768px)").matches) {
        var driftAll = document.querySelectorAll('.tf-image-zoom');
        var pane = document.querySelector('.tf-zoom-main');
        $(driftAll).each(function(i, el) {
            new Drift(
                el, {
                zoomFactor: 2,
                paneContainer: pane,
                inlinePane: false,
                handleTouch: false,
                hoverBoundingBox: true,
                containInline: true,
                }
            );
        });
      }
      if (matchMedia("only screen and (min-width: 768px)").matches) {
        var driftAll1 = document.querySelectorAll('.tf-image-zoom1');
        var pane1 = document.querySelector('.tf-zoom-main1');
        $(driftAll1).each(function(i, el) {
            new Drift(
                el, {
                zoomFactor: 2,
                paneContainer: pane1,
                inlinePane: false,
                handleTouch: false,
                hoverBoundingBox: true,
                containInline: true,
                }
            );
        });
      }
    }

    var image_zoom_magnifier = function () {
        var driftAll = document.querySelectorAll('.tf-image-zoom-magnifier');
        $(driftAll).each(function(i, el) {
            new Drift(
                el, {
                zoomFactor: 2,
                inlinePane: true,
                containInline: false,
                }
            );
        });
    }

    var image_zoom_inner = function () {
        var driftAll = document.querySelectorAll('.tf-image-zoom-inner');
        var pane = document.querySelector('.tf-product-zoom-inner');
        $(driftAll).each(function(i, el) {
            new Drift(
                el, {
                paneContainer: pane,
                zoomFactor: 2,
                inlinePane: false,
                containInline: false,
                }
            );
        });
    }

    var lightboxswiper = function () {

        const lightbox = new PhotoSwipeLightbox({
            gallery: '#gallery-swiper-started',
            children: 'a',
            pswpModule: PhotoSwipe,
            bgOpacity: 1,
            secondaryZoomLevel: 2,
            maxZoomLevel: 3,
        });
        lightbox.init();

        lightbox.on('change', () => {
            const { pswp } = lightbox;
            var _g = rcGallerySwiper(); if (_g) _g.slideTo(pswp.currIndex, 0, false);
        });

        lightbox.on('afterInit', () => {
            var _g2 = rcGallerySwiper(); if (_g2 && _g2.params.autoplay && _g2.params.autoplay.enabled) { _g2.autoplay.stop(); }
        });

        lightbox.on('closingAnimationStart', () => {
            const { pswp } = lightbox;
            var _g = rcGallerySwiper(); if (_g) _g.slideTo(pswp.currIndex, 0, false);
            var _g3 = rcGallerySwiper(); if (_g3 && _g3.params.autoplay && _g3.params.autoplay.enabled) { _g3.autoplay.start(); }
        });

    }
    var lightboxswiper1 = function () {

        const lightbox = new PhotoSwipeLightbox({
            gallery: '#gallery-swiper-started1',
            children: 'a',
            pswpModule: PhotoSwipe,
            bgOpacity: 1,
            secondaryZoomLevel: 2,
            maxZoomLevel: 3,
        });
        lightbox.init();

    }
    var lightboxswiper2 = function () {

        const lightbox = new PhotoSwipeLightbox({
            gallery: '#gallery-swiper-started2',
            children: 'a',
            pswpModule: PhotoSwipe,
            bgOpacity: 1,
            secondaryZoomLevel: 2,
            maxZoomLevel: 3,
        });
        lightbox.init();

    }
    var lightboxswiper3 = function () {

        const lightbox = new PhotoSwipeLightbox({
            gallery: '#gallery-swiper-started3',
            children: 'a',
            pswpModule: PhotoSwipe,
            bgOpacity: 1,
            secondaryZoomLevel: 2,
            maxZoomLevel: 3,
        });
        lightbox.init();

    }
    var lightboxswiper4 = function () {

        const lightbox = new PhotoSwipeLightbox({
            gallery: '#gallery-swiper-started4',
            children: 'a',
            pswpModule: PhotoSwipe,
            bgOpacity: 1,
            secondaryZoomLevel: 2,
            maxZoomLevel: 3,
        });
        lightbox.init();

    }

    
    var lightbox = function () {

        const lightbox = new PhotoSwipeLightbox({
            gallery: '#gallery-started',
            children: 'a',
            pswpModule: PhotoSwipe,
            bgOpacity: 1,
            secondaryZoomLevel: 2,
            maxZoomLevel: 3,
        });
        lightbox.init();

    }

    var model_viewer = function () {

        if ($(".tf-model-viewer").length) {
   
            $(".tf-model-viewer-ui-button").on("click", function (e) {
                $(this).closest(".tf-model-viewer").find("model-viewer").removeClass("disabled");
                $(this).closest(".tf-model-viewer").toggleClass("active");
            });
            $(".tf-model-viewer-ui").on("dblclick", function (e) {
                $(this).closest(".tf-model-viewer").find("model-viewer").addClass("disabled");
                $(this).closest(".tf-model-viewer").toggleClass("active");
            });
        }

    }

  // Dom Ready
  $(function () {
    section_zoom();
    image_zoom();
    image_zoom_magnifier();
    image_zoom_inner();

    lightboxswiper();
    lightboxswiper1();
    lightboxswiper2();
    lightboxswiper3();
    lightboxswiper4();
    
    lightbox();
    model_viewer();
  });
})(jQuery);


